import { render } from "./Offers.vue?vue&type=template&id=58c287ec&scoped=true&ts=true"
import script from "./Offers.vue?vue&type=script&lang=ts"
export * from "./Offers.vue?vue&type=script&lang=ts"

import "./Offers.vue?vue&type=style&index=0&id=58c287ec&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c287ec"]])

export default __exports__